import { Star } from "lucide-react";
import { useLang } from "@/i18n";
import { Reveal, SectionHeading } from "@/components/Reveal";

const Stars = () => (
  <div className="flex gap-1">
    {[...Array(5)].map((_, i) => (
      <Star key={i} className="h-4 w-4 fill-amber-400 text-amber-400" />
    ))}
  </div>
);

export const Reviews = () => {
  const { t } = useLang();
  const r = t.reviews;

  return (
    <section className="mx-auto max-w-7xl px-5 pb-28 sm:px-8">
      <SectionHeading eyebrow={r.eyebrow} title={r.title} accent={r.accent} />
      <div data-testid="reviews-grid" className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {r.items.map((item, i) => (
          <Reveal key={item.name} delay={i * 0.08}>
            <figure
              data-testid={`review-card-${i}`}
              className="flex h-full flex-col rounded-3xl border border-white/10 bg-[#0F0F14] p-7 transition-all duration-500 hover:-translate-y-1 hover:border-amber-400/40"
            >
              <Stars />
              <blockquote className="mt-5 flex-1 text-sm leading-relaxed text-slate-300">
                “{item.text}”
              </blockquote>
              <figcaption className="mt-6 border-t border-white/10 pt-4">
                <span className="block font-display text-sm font-bold text-white">
                  {item.name}
                </span>
                <span className="mt-1 block text-xs text-slate-500">{item.place}</span>
                <span className="mt-2 inline-block rounded-full bg-amber-400/10 px-3 py-1 font-mono-alt text-[10px] uppercase tracking-[0.2em] text-amber-300">
                  {item.tag}
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2}>
        <p className="mt-6 text-center font-mono-alt text-[10px] uppercase tracking-[0.25em] text-slate-600">
          {r.disclaimer}
        </p>
      </Reveal>
    </section>
  );
};
